<template>
  <div v-if="!showFooter" class="footer_container">
    <div class="content">
      <div class="footer-top">
        <div class="footer-left">
          <div class="nav-container">
            <div class="nav-line">
              <ul class="nav-column" v-for="(column, index) in navColumns" :key="index">
                <li v-for="item in column" :key="item.text">
                  <router-link v-if="item.path" :to="item.path">{{ item.text }}</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-right-container">
            <div class="footer-right-img">
              <img src="../../assets/img/erweima.jpg" @click="handlToHome"/>
            </div>
            <div class="footer-right-item">
              <div class="footer-right-item-title">
                <!-- 咨询热线 -->
              </div>
              <div class="footer-right-item-content">
                40008888186
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-bottom-container">
          <div class="footer-bottom-left">
            <img src="../../assets/img/logo.png" />
          </div>
          <div class="footer-bottom-right">
            版权所有 中地大珠宝检测有限公司  鄂ICP备06011420号-1
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { featchCategory } from '@/api'
export default {
  data() {
    return {
      day: "",
      hours: "",
      minute: "",
      second: "",
      categoryList: [],
      nowYear: new Date().getFullYear(),
      showFooter: false,
      topNav: [
        { text: '首页', path: '/' },
        { text: '新闻', path: '/news' },
        { text: '研究', path: '/research' },
        { text: '宝石百科', path: '/gem-encyclopedia' },
        { text: '检测业务', path: '/inspection' },
        { text: '关于我们', path: '/about' }
      ],
      navColumns: [
        [
          { text: '首页', path: '/' },
          { text: '新闻', path: '/tags?categoryId=32' },
          { text: '研究', path: '/tags?categoryId=33' },
          { text: '宝石百科', path: '/gem?categoryId=34' },
          { text: '关于GIC', path: '/news/industry' }
        ],
        [
          { text: '新闻', path: '/tags?categoryId=32' },
        ],
        [
          { text: '研究', path: '/tags?categoryId=33' },
        ],
        [
          { text: '宝石百科', path: '/gem?categoryId=34' },
        ],
        [
          { text: '检测业务', path: '/certificate-check' },
          { text: '证书查询', path: '/certificate-check' },
          { text: '检测流程及范围', path: '/rangeDetail' },
          { text: '检测仪器及方法', path: '/instrument' }
        ],
        [
          { text: '关于我们', path: '/about-gic' },
          { text: '关于GIC', path: '/about-gic' },
          { text: '联系我们', path: '/contact-us' },
          // { text: '专家介绍', path: '/experts' },
          { text: '加入GIC', path: '/join-us' }
        ]
      ],
    }
  },
  watch: {
    $route(newVal, old) {
      if (newVal.fullPath === '/message' || newVal.fullPath === '/chat' || newVal.fullPath === '/newposts') {
        this.showFooter = true
      } else {
        this.showFooter = false
      }
    }
  },
  created() {
    this.timer = setInterval(this.runTime, 1000);
  },
  mounted() {
    this.fetchCategoryList()
  },
  methods: {
    fetchCategoryList() {
        featchCategory().then(res => {
            this.categoryList.push(...res.data)
            console.log('-1111122223333---categoryList', this.categoryList)
        })
    },
    runTime() {
      var timeold =
          new Date().getTime() -
          new Date(1627747200000).getTime();
      var msPerDay = 24 * 60 * 60 * 1000;
      var daysold = Math.floor(timeold / msPerDay);
      var day = new Date();
      this.day = daysold;
      this.hours = day.getHours();
      this.minute = day.getMinutes();
      this.second = day.getSeconds();
    },
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover {
      color: #c09836;
  }
@keyframes yb {
  10% {
    transform: rotate(15deg);
  }

  20% {
    transform: rotate(-10deg);
  }

  30% {
    transform: rotate(5deg);
  }

  40% {
    transform: rotate(-5deg);
  }

  50%,
  100% {
    transform: rotate(0deg);
  }
}


.footer_container {
  padding: 40px 80px 20px 80px;
  position: relative;
  bottom: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000;
  // background: url(../../assets/img/footBg.jpg) no-repeat center;
  background-position: 100% 0;
  height: 300px;
  .searchBox {
      right: 50px;
      display: flex;
      -ms-flex-direction: column;
      flex-direction: column;

      .search_ico {
          position: absolute;
          right: 5px;
          top: 0;
          padding: 0;
          margin: 0;
          line-height: 60px;


          div {
              width: 180px;
              border: 1px solid var(--border-line);
              height: 35px;
              line-height: 35px;
              margin-top: 13px;
              font-size: 15px;
              border-radius: 5px;
              color: #82848a;

              .iconfont {
                  font-weight: 700;
                  margin: 0 5px;
              }

              span {
                  border: 1px solid var(--border-line);
                  border-radius: 3px;
                  padding: 2px 2px;
                  margin-left: 15px;
                  background-color: var(--background-color);
              }
          }
      }
  }

  .xiangguan-link {
    font-size: 16px;
    color: white;
  }

  .content {
    // margin: 0 auto;
    // position: relative;
    // text-align: center;
    display: flex;
    width: 90%;
    height: 100%;
    margin: 0 auto;
    flex-direction: column;
    justify-content: space-between;
    .footer-top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      height: 85%;

      .footer-left {
        width: 70%;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 32px;
        .title {
          font-size: 20px;
          color: #ffffff;
          margin-bottom: 12px;
        }
      }

      .footer-right {
        width: 30%;

        .footer-right-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          position: absolute;
          bottom: 20%;

          .footer-right-img {
            width: 80%;
            height: 80%;
            margin: 0 auto;

            img {
              width: calc(70%);
              aspect-ratio: 1;
            }
          }

          .footer-right-item {
            width: 80%;

            .footer-right-item-title {
              font-size: 18px;
              color: white;
            }

            .footer-right-item-content {
              margin-top: 10px;
              font-size: 26px;
              color: white;
            }
          }
        }
      }
    }
    

    .footer-bottom {
      width: 100%;
      height: 10%;
      bottom: 0;

      .footer-bottom-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        height: 100%;

        .footer-bottom-left {
          height: 100%;
          img {
            height: calc(100%);
            // aspect-ratio: 1;
          }
        }

        .footer-bottom-right {
          font-size: 14px;
          color: white;
          margin-left: 10px;
        }
      }
    }

    .site {
      font-size: 16px;
      color: white;
      padding-left: 80px;
      position: relative;
      width: 60%;
      .nav {
        li {
          color: white !important;
          float: left;
          display: block;
          font-size: 18px;
          padding: 0 20px;
          position: relative;
        }
      }

      p {
        margin: 10px 0;
      }

      a {
        text-decoration: none;
        color: var(--theme-color);

        &:hover {
          color: var(--theme-color);
        }
      }
      .web-notice {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        right: 20px;
        bottom: 0;
        .notice-text {
          padding-left: 40px;
          color: rgba(255, 255, 255, 0.7);
          font-size: 16px;
          padding-right: 40px;

          .hand-style {
            font-size: 16px;
            transition: 0.3s;
          }
        }
      }
      .hand-style {
        color: #fff;
        font-size: 20px;
        transition: 0.3s;
      }
      .run_time {
        height: 20px;
        align-items: center;

        svg {
          width: 19px;
          height: 19px;
          vertical-align: -4px;
          animation: yb 1s linear infinite;
        }

        span {
          line-height: 20px;
          font-size: 16px;
          padding-left: 5px;

          strong {
            color: var(--theme-color);
          }
        }
      }
    }

    .site-number {

      i {
        display: inline-block;
        font-size: 12px;
      }

      .site_pv,
      .site_uv,
      .online_user {
        position: relative;
        display: inline-block;
        margin-right: 4px;
        height: 24px;
        padding-left: 10px;
        line-height: 24px;
        overflow: hidden;
        font-size: 12px;
        font-weight: 700;
        color: var(--background-color);
        background: var(--text-color1);
        border-radius: 5px;
      }

      .pv_num,
      .uv_num,
      .online_num {
        display: inline-block;
        font-size: 12px;
        padding: 0 15px;
      }

      .pv_num {
        background: linear-gradient(0deg, #d0339b, #d03336);
      }

      .uv_num {
        background: linear-gradient(0deg, #e2c63a, #f58044);
      }

      .online_num {
        background: linear-gradient(0deg, #367eda, #964fdb);

      }


    }

  }
}

@media screen and (max-width: 1118px) {
  .site {
    display: none;
  }
  .footer-left {
    width: 100% !important;
  }

  .footer-right {
    display: none;
  }

  .footer-bottom {
    display: none;
  }
}

.nav-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 20px;
  // background: #f5f5f5;
  width: 90%;

  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nav-line {
    display: flex;
    justify-content: space-between;
    // align-items: center;
  }
}

.nav-column {
  list-style: none;
  padding: 0;
  margin: 0;
}

// .nav-column li {
//   margin-bottom: 12px;
// }

.nav-column a {
  position: relative;
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  display: inline-block;
  overflow: hidden;
}

.nav-column a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #007bff;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-column a:hover::after {
  transform: scaleX(1);
}

.nav-column a:hover {
  color: #007bff;
}

.nav-column li:first-child {
  margin-bottom: 15px;
}

.nav-column li:first-child a {
  font-size: 18px;
  font-weight: bold;
  
}
</style>
